module.exports = __webpack_public_path__ + "12f2c346acb9f0e184acd50e816c3396.woff2";